import script from "./StatsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./StatsCard.vue?vue&type=script&setup=true&lang=js"

import "./StatsCard.vue?vue&type=style&index=0&id=6ad4148c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ad4148c"]])

export default __exports__